export default __webpack_public_path__ + "static/media/icon_TVOC.a4511138.svg";